(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .constant('paginationConstants', {
            'itemsPerPage': 10
        });
})();
